module.exports = __webpack_public_path__ + "img/lxwm.eb83029b.png";